import * as React from 'react'
import type { SVGProps } from 'react'
const SvgDescription = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" {...props}>
		<mask
			id="mask0_1779_12369"
			style={{ maskType: 'alpha' }}
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="24"
			height="24"
		>
			<rect width="24" height="24" fill="currentColor" />
		</mask>
		<g mask="url(#mask0_1779_12369)">
			<path
				d="M8.25 17.75H15.75V16.25H8.25V17.75ZM8.25 13.75H15.75V12.25H8.25V13.75ZM6.3077 21.5C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30773C4.5 3.8026 4.675 3.37503 5.025 3.02503C5.375 2.67503 5.80257 2.50003 6.3077 2.50003H14.25L19.5 7.74998V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5H6.3077ZM13.5 8.49998V4.00001H6.3077C6.23077 4.00001 6.16024 4.03206 6.09612 4.09616C6.03202 4.16027 5.99997 4.2308 5.99997 4.30773V19.6923C5.99997 19.7692 6.03202 19.8397 6.09612 19.9039C6.16024 19.968 6.23077 20 6.3077 20H17.6922C17.7692 20 17.8397 19.968 17.9038 19.9039C17.9679 19.8397 18 19.7692 18 19.6923V8.49998H13.5Z"
				fill="currentColor"
			/>
		</g>
	</svg>
)
export default SvgDescription
